import type { Logger } from "@expert/logging";

import { useChatExpertAssistSessions } from "./useChatExpertAssistSessions";
import { useGaiaMessageEvents } from "./useGaiaMessageEvents";
import { useVoiceExpertAssistSessions } from "./useVoiceExpertAssistSessions";

export const useSetupSubscriptions = (logger: Logger) => {
    useGaiaMessageEvents(logger);
    useVoiceExpertAssistSessions(logger);
};

export const useSetupChatGaiaSubscriptions = (logger: Logger) => {
    useGaiaMessageEvents(logger);
    useChatExpertAssistSessions(logger);
};
